import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "42.268",
  width: "50",
  viewBox: "0 0 50 42.268",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#eec74a",
    d: "M47.165 27.663a10.567 10.31 0 0 1-10.567 10.31 10.567 10.31 0 0 1-10.567-10.31 10.567 10.31 0 0 1 10.57-10.31 10.567 10.31 0 0 1 10.57 10.31z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#c69b24",
    d: "M44.502 27.663a7.904 7.646 0 0 1-7.904 7.646 7.904 7.646 0 0 1-7.904-7.65 7.904 7.646 0 0 1 7.904-7.65 7.904 7.646 0 0 1 7.904 7.644z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    fill: "#020202",
    d: "M50 18.3a10.48 10.223 0 0 1-10.48 10.22A10.48 10.223 0 0 1 29.037 18.3a10.48 10.223 0 0 1 10.48-10.224A10.48 10.223 0 0 1 50 18.3z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#eec74a",
    d: "M50 15.292a10.48 10.223 0 0 1-10.48 10.223 10.48 10.223 0 0 1-10.482-10.223A10.48 10.223 0 0 1 39.518 5.07 10.48 10.223 0 0 1 50 15.29z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#c69b24",
    d: "M47.337 15.292a7.818 7.56 0 0 1-7.818 7.56 7.818 7.56 0 0 1-7.82-7.56 7.818 7.56 0 0 1 7.82-7.56 7.818 7.56 0 0 1 7.81 7.56z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    fill: "#020202",
    d: "M41.84 22.08a20.19 20.19 0 0 1-20.19 20.188 20.19 20.19 0 0 1-20.19-20.19A20.19 20.19 0 0 1 21.65 1.89a20.19 20.19 0 0 1 20.19 20.19z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#ff3a2f",
    d: "M40.378 20.19a20.19 20.19 0 0 1-20.19 20.188A20.19 20.19 0 0 1 0 20.188 20.19 20.19 0 0 1 20.19 0a20.19 20.19 0 0 1 20.188 20.19z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    d: "M35.997 20.704a16.58 16.41 0 0 1-16.58 16.41 16.58 16.41 0 0 1-16.582-16.41 16.58 16.41 0 0 1 16.58-16.408 16.58 16.41 0 0 1 16.582 16.408z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M35.825 20.19A15.636 15.636 0 0 1 20.19 35.824 15.636 15.636 0 0 1 4.552 20.19 15.636 15.636 0 0 1 20.19 4.552 15.636 15.636 0 0 1 35.824 20.19z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    d: "M35.825 20.19A15.636 15.636 0 0 1 20.19 35.824 15.636 15.636 0 0 1 4.552 20.19 15.636 15.636 0 0 1 20.19 4.552 15.636 15.636 0 0 1 35.824 20.19z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "none",
    d: "M5.155 22.423c0-8.59 6.958-15.636 15.636-15.636 6.88 0 12.72 4.467 14.78 10.653-1.29-7.302-7.64-12.887-15.38-12.887-8.59 0-15.63 6.96-15.63 15.636 0 1.71.26 3.35.776 4.89-.087-.86-.172-1.807-.172-2.666z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M20.79 6.787c-8.59 0-15.636 6.96-15.636 15.636 0 .945.086 1.804.258 2.663C7.474 31.272 13.316 35.74 20.19 35.74c8.59 0 15.635-6.96 15.635-15.637 0-.945-.086-1.804-.258-2.663-2.062-6.186-7.904-10.653-14.777-10.653z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#142a3b",
    d: "M20.104 6.787c-.86 0-.86.688-.946 1.375l-.914 10.422a3.35 3.35 0 0 0-2.008 3.066A3.35 3.35 0 0 0 19.588 25a3.35 3.35 0 0 0 3.346-3.285l4.73-3.072c.516-.43 1.2-.86.772-1.633-.43-.773-1.03-.688-1.717-.344l-5.11 2.32a3.35 3.35 0 0 0-.34-.228L20.96 7.99c0-.343 0-1.203-.86-1.203z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    d: "M28.18 17.783c-.345-.773-1.118-.687-1.89-.257l-4.04 1.89V8.076c0-.86-.686-1.546-1.545-1.546s-1.547.687-1.547 1.546v11.512c-1.374.43-2.405 1.718-2.405 3.265 0 1.89 1.546 3.35 3.35 3.35s3.35-1.546 3.35-3.35c0-.172 0-.344-.085-.516l4.21-2.577c.86-.516 1.03-1.203.6-1.976z"
  })]
});